<template>
  <span class="decimal-number">
    {{int}}<span class="decimal">{{decimal}}</span>
  </span>
</template>

<script>
import moneyUtils from '../utils/money';

export default {
  name: 'DecimalNumber',
  props: {
    value: {
      required: true,
      type: Number,
    },
  },
  computed: {
    int() {
      const integer = Math.abs(moneyUtils.extractRoundedIntegerPart(this.value, 1));
      return moneyUtils.formatAmount(integer);
    },
    decimal() {
      const number = Math.abs(moneyUtils.extractRoundedDecimalPart(this.value, 1));
      return `.${number}`;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/base-components/DecimalNumber.vue